import { render, staticRenderFns } from "./PennTesting.vue?vue&type=template&id=5b7786f4&scoped=true"
import script from "./PennTesting.vue?vue&type=script&lang=js"
export * from "./PennTesting.vue?vue&type=script&lang=js"
import style0 from "./PennTesting.vue?vue&type=style&index=0&id=5b7786f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7786f4",
  null
  
)

export default component.exports